import React, { MutableRefObject, useEffect, useState } from 'react';
import type { IStatusPanelParams } from 'ag-grid-community';
import styles from '../FinancialReport.module.scss';

export type ZeroRowsStatusBarSetter = (text: React.ReactNode | string) => void;

interface ZeroRowsStatusBarProps extends IStatusPanelParams {
  setterRef?: MutableRefObject<ZeroRowsStatusBarSetter | null>;
}

// In ag-grid v34, getStatusPanel() no longer returns the React class instance, so we use a
// setterRef passed via statusPanelParams to expose the state updater directly.
export function ZeroRowsStatusBar({ setterRef }: ZeroRowsStatusBarProps) {
  const [statusBarText, setStatusBarText] = useState<React.ReactNode | string>('');

  useEffect(() => {
    if (!setterRef) return;
    setterRef.current = setStatusBarText;
    return () => {
      setterRef.current = null;
    };
  }, [setterRef]);

  return statusBarText ? <div className={styles.statusBar}>{statusBarText}</div> : null;
}
